var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterNameL(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter_name_l",
    transform: "translate(-476 -1130)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5320",
    "data-name": "Rectangle 5320",
    transform: "translate(476 1130)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-name_1_",
    "data-name": "icons8-name (1)",
    d: "M4.25,2A2.258,2.258,0,0,0,2,4.25v13.5A2.258,2.258,0,0,0,4.25,20h13.5A2.258,2.258,0,0,0,20,17.75V4.25A2.258,2.258,0,0,0,17.75,2Zm0,1.5h13.5a.74.74,0,0,1,.75.75v13.5a.74.74,0,0,1-.75.75H4.25a.74.74,0,0,1-.75-.75V4.25A.74.74,0,0,1,4.25,3.5ZM11,6.5a2.992,2.992,0,0,0-2.156,5.074A4.492,4.492,0,0,0,6.5,15.5H8a3,3,0,0,1,6,0h1.5a4.492,4.492,0,0,0-2.344-3.926A2.992,2.992,0,0,0,11,6.5ZM11,8A1.5,1.5,0,1,1,9.5,9.5,1.488,1.488,0,0,1,11,8Z",
    transform: "translate(477 1131)",
    fill: "#1e3772"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterNameL);
export default __webpack_public_path__ + "static/media/filter_name_l.59be221672d137029d234f48e71af7a4.svg";
export { ForwardRef as ReactComponent };